import { MainStore, WindowsIndex } from "../types/types";

/**
 * See description in types/types.ts
 */
export let mainStore: MainStore = {
	webContents: {},
	downloads: {},
	browserWindowOptions: {},
	unattachedChildWindows: {},
};

/**
 * See description in types/types.ts
 */
export let windowsIndex: WindowsIndex = {
	byWindowName: {},
	byWebContentsName: {},
	byWebContentsId: {},
};
